<template>
  <div style="background-color: #f7f7f7; padding: 1px" class="flex-column list-half top">
    <div class="panel3 p1" ref="box">
      <el-tabs tab-position="left">
        <el-tab-pane :label="item.label" v-for="(item, index) in items" :key="index">
          <Entity :isedit="false" :config="item" :key="index" :value="roles" class="panel3 p01"></Entity>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import Entity from './Entity.vue'
export default {
  props: {
    config: Object,
    value: String
  },
  components: { Entity },
  data() {
    return { checked: false, showStyle: null, roles: {}, selection: {} }
  },
  computed: {
    items() {
      return this.$matrix.GetEntitys(this.config.Role || this.$matrix.GetCurrentRoleName())
    }
  },

  methods: {
    init(value) {
      let res = {}
      let initData = {}
      let getValue = (name, defaultValue) => {
        if (initData[name] === undefined) return defaultValue
        return initData[name]
      }
      let setValue = (name, defaultValue) => {
        res[name] = getValue(name, defaultValue)
      }
      try {
        if (value) {
          if (typeof value === 'string') initData = JSON.parse(value)
          else initData = value
        }
      } catch (e) {}
      let foo = (item) => {
        if (res[item.path]) setValue(item.path, true)
        if (item.query) setValue(item.path + '_query', true)
        if (item.edit) {
          setValue(item.path + '_add', true)
          setValue(item.path + '_modify', true)
          setValue(item.path + '_del', true)
          setValue(item.path + '_download', true)
        }
        if (item.acts) {
          item.acts.forEach((act) => {
            setValue(act.path, true)
          })
        }
        if (item.children) {
          item.children.forEach((c) => {
            foo(c)
          })
        }
      }
      this.items.forEach((item) => {
        foo(item)
      })
      return res
    }
  },
  created() {
    this.roles = this.init(this.value)
  }
}
</script>
